const buildActivityProfile = (activities) => {
    if (!activities || activities.length === 0) return []

    const byType = {}
    activities.forEach((activity) => {
        const type = activity.activityType || 'other'
        if (!byType[type]) {
            byType[type] = { type, count: 0, efforts: [], modes: [] }
        }

        byType[type].count += 1
        if (activity.estimatedEffort) byType[type].efforts.push(activity.estimatedEffort)
        if (activity.deliveryMode) byType[type].modes.push(activity.deliveryMode)
    })

    return Object.values(byType)
        .sort((a, b) => b.count - a.count)
        .map((item) => {
            const effortCounts = { low: 0, medium: 0, high: 0 }
            item.efforts.forEach((effort) => {
                if (effortCounts[effort] != null) effortCounts[effort] += 1
            })

            const dominantEffort =
                Object.entries(effortCounts).sort((a, b) => b[1] - a[1])[0]?.[0] || 'medium'
            const uniqueModes = [...new Set(item.modes)]

            return { ...item, dominantEffort, uniqueModes }
        })
}

export default buildActivityProfile
